import Forward5RoundedIcon from '@mui/icons-material/Forward5Rounded';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import Replay5RoundedIcon from '@mui/icons-material/Replay5Rounded';
import { CircularProgress, IconButton } from '@mui/material';
import React from 'react';
import css from '../MomentMergeVideoPlayer.module.scss';

type CenterControlsProps = {
  isPlaying: boolean;
  isActiveVideoLoading: boolean;
  showSkipFeedback: 'forward' | 'backward' | null;
  onTogglePlayPause: (e: React.MouseEvent) => void;
};

export const CenterControls: React.FC<CenterControlsProps> = ({
  isPlaying,
  isActiveVideoLoading,
  showSkipFeedback,
  onTogglePlayPause,
}) => {
  return (
    <>
      {!isPlaying && (
        <IconButton className={css.centerPlayButton} onClick={onTogglePlayPause}>
          <PlayArrowRoundedIcon fontSize="large" />
        </IconButton>
      )}

      {showSkipFeedback && (
        <IconButton
          className={`${css.centerSkipButton} ${showSkipFeedback === 'backward' ? css.left : css.right}`}
        >
          {showSkipFeedback === 'backward' ? (
            <Replay5RoundedIcon fontSize="large" />
          ) : (
            <Forward5RoundedIcon fontSize="large" />
          )}
        </IconButton>
      )}

      {isActiveVideoLoading && (
        <div className={css.loadingOverlay}>
          <CircularProgress size={48} thickness={4} />
        </div>
      )}
    </>
  );
};
